import React from 'react';
import PropTypes from 'prop-types';

import IconAdd from './svg/IconAdd';
import IconCart from './svg/IconCart';
import IconAddedCart from './svg/IconAddedCart';

function ColumnRowActions({ width, onClickCart, isInCart, onClickPlaylist, style }) {
  return (
    <div className='flexRow' style={{ width, gap: 5, textAlign: `-webkit-center`, cursor: 'pointer', zIndex: 50, ...style}}>
      <div className={'column-extra-action'} onClick={onClickCart}>
        { isInCart ? <IconAddedCart color={'#FFFFFF'} size={20} /> : <IconCart color={'#FFFFFF'} size={20} /> }
      </div>
      <div className={'column-extra-action'} onClick={onClickPlaylist}>
        <IconAdd color={'white'} size={20} />
      </div>
    </div>
  )
}



ColumnRowActions.propTypes = {
  width: PropTypes.number.isRequired,
  onClickCart: PropTypes.func.isRequired,
  isInCart: PropTypes.bool.isRequired,
  onClickPlaylist: PropTypes.func.isRequired,
  style: PropTypes.object,
}

export default ColumnRowActions;
